import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Roles, hasHrRole } from '../../constant/roles';
import { UserStore } from '../../store/user.store';

@Injectable({
    providedIn: 'root'
})
export class CheckHrOrManager implements CanLoad, CanActivate {
    constructor(private router: Router, private usrStore: UserStore) {
    }

    async canLoad() {
        console.log('CheckHrOrManager');
        if (hasHrRole(this.usrStore.userLogged.roles) || this.usrStore.userLogged.roles?.includes(Roles.MANAGER))
            return true;
        else
            return false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        console.log('CheckHrOrManager => check canActivate');
        if (hasHrRole(this.usrStore.userLogged?.roles) || this.usrStore.userLogged?.roles?.includes(Roles.MANAGER))
            return true;
        else
            return false;
    }
}
